import { render } from "./ModalWithOpener.vue?vue&type=template&id=355d19cf"
import script from "./ModalWithOpener.vue?vue&type=script&lang=js"
export * from "./ModalWithOpener.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__